import { useEffect } from 'react';
import { STUDIO_DOCUMENT_TITLES } from '../config';

/**
 * Sets document.title for a studio route. Restores the studio base title on unmount
 * so sibling studio screens can replace it cleanly.
 */
export function useStudioDocumentTitle(
  title: string = STUDIO_DOCUMENT_TITLES.base
): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
